<template>
  <div class="wrapper">
    <div class="header">
      <div class="left">
        <span class="title">直播间商品（0）</span>
        <span class="tag">未开播</span>
        <span class="tips">直播间最多支持100个商品</span>
      </div>
      <div>
        <el-button
          class="btn del"
          :disabled="listSelected.length == 0"
          @click="removeList"
          >批量删除</el-button
        >
        <el-button class="btn add" icon="el-icon-plus" @click="visible = true"
          >添加商品</el-button
        >
      </div>
    </div>
    <el-table
      ref="dragTable"
      :key="tableKey"
      :data="list"
      row-key="id"
      class="table"
      empty-text="直播间内没有商品，快去添加吧!"
      @selection-change="handleSelectionChangeList"
    >
      <el-table-column
        type="selection"
        width="66"
        align="right"
      ></el-table-column>
      <el-table-column label="商品序号" width="94">
        <template slot-scope="{ row }">
          <div style="display: flex; align-items: center">
            <el-tooltip
              class="item"
              effect="dark"
              content="拖拽跳转顺序"
              placement="top-start"
            >
              <div class="draggable"></div>
            </el-tooltip>
            <el-input v-model="row.index" />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="商品名称" width="249">
        <template slot-scope="{ row }">
          <div class="goods">
            <div class="img">
              <img :src="row.img" width="100%" height="100%" alt="" />
            </div>
            <div class="name">
              <span>{{ row.name }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="商品ID" prop="id" width="124"></el-table-column>
      <el-table-column
        label="商品价格"
        prop="price"
        width="125"
        align="right"
      ></el-table-column>
      <el-table-column
        label="商品来源"
        prop="source"
        width="114"
      ></el-table-column>
      <el-table-column label="商品卖点" width="148">
        <template slot-scope="{ row }">
          <div class="md">{{ row.md }}</div>
          <a class="ctrl" @click="setMd(row)">{{
            row.md.trim().length == 0 ? "设置卖点" : "修改"
          }}</a>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{ row }">
          <a class="ctrl" style="margin-right: 12px" @click="remove(row)"
            >删除</a
          >
          <a class="ctrl">刷新</a>
        </template>
      </el-table-column>
    </el-table>

    <el-drawer
      class="drawer"
      :visible.sync="visible"
      direction="rtl"
      title="添加商品"
      :size="864"
      :wrapperClosable="false"
    >
      <div class="content">
        <el-tabs>
          <el-tab-pane label="橱窗商品">
            <div class="search-box">
              <span>商品ID/关键词</span>
              <el-input v-model="id" placeholder="请输入商品ID/关键词" />
              <span>商品来源</span>
              <el-select v-model="source">
                <el-option label="全部" value=""></el-option>
                <el-option label="淘宝" value="淘宝"></el-option>
                <el-option label="小店" value="小店"></el-option>
                <el-option label="京东" value="京东"></el-option>
                <el-option label="考拉" value="考拉"></el-option>
                <el-option label="唯品会" value="唯品会"></el-option>
                <el-option label="苏宁" value="苏宁"></el-option>
                <el-option label="洋码头" value="洋码头"></el-option>
              </el-select>
              <el-button class="btn sub" @click="search">查询</el-button>
              <el-button
                class="btn"
                @click="
                  id = source = '';
                  search();
                "
                >重置</el-button
              >
            </div>
            <el-table
              ref="goodsTable"
              @selection-change="handleSelectionChangeGoods"
              :data="goodsList"
              class="table"
              empty-text="直播间内没有商品，快去添加吧!"
            >
              <el-table-column
                type="selection"
                width="42"
                align="right"
              ></el-table-column>
              <el-table-column label="商品名称" width="315">
                <template slot-scope="{ row }">
                  <div class="goods">
                    <div class="img">
                      <img :src="row.img" width="100%" height="100%" alt="" />
                    </div>
                    <div class="name">
                      <span>{{ row.name }}</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="商品ID"
                prop="id"
                width="158"
              ></el-table-column>
              <el-table-column
                label="商品价格"
                prop="price"
                width="158"
                align="right"
              ></el-table-column>
              <el-table-column label="商品来源" prop="source"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane>
            <template slot="label">
              <span>商品链接 </span>
              <svg>
                <use href="#icon-yiwen" />
              </svg>
            </template>
          </el-tab-pane>
        </el-tabs>
        <div class="footer">
          <div>
            已选
            <span style="color: rgb(101, 87, 250)">{{
              goodsSelectedList.length
            }}</span>
            项 / {{ goodsList.length }}
            <span style="margin-left: 16px"
              >新加商品将展示在商品列表最后面</span
            >
          </div>
          <div>
            <el-button
              class="btn sub"
              type="primary"
              :disabled="goodsSelectedList.length == 0"
              @click="add"
              >添加</el-button
            >
            <el-button class="btn" @click="visible = false">取消</el-button>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Sortable from "sortablejs";
import { submit } from "@/api/chapterMock";

export default {
  data() {
    return {
      tableKey: new Date().getTime(),
      list: [],
      goods: [
        {
          name: "溢源 香辣海带结576g即食零食小包装脆爽不辣办公室休闲零食",
          img: "https://p6-aio.ecombdimg.com/img/temai/249ee8d1505cd5aac1284ac54b888668www800-800~tplv-resize:200:0.webp",
          id: "3473223254431428715",
          price: "￥29.9",
          source: "小店",
        },
        {
          name: "【主播推荐】溢源福建霞浦特产烘干小海带条干货120g薄嫩火锅食材",
          img: "https://p3-aio.ecombdimg.com/img/temai/99c7ff8528f98a4f86d78b59ec137517www800-800~tplv-resize:200:0.webp",
          id: "3434416083023592460",
          price: "￥26.9",
          source: "小店",
        },
        {
          name: "新未流心榴莲饼整箱小吃食品休闲网红零食糕点心超浓榴莲酥500g",
          img: "https://p6-aio.ecombdimg.com/img/temai/421af1dcff26fa34f02a58d9fdedbaebwww800-800~tplv-resize:200:0.webp",
          id: "3476372498650664534",
          price: "￥13.9",
          source: "小店",
        },
        {
          name: "溢源香辣海带结小包装解馋零食休闲食品办公室开袋即食海带结256g",
          img: "https://p3-aio.ecombdimg.com/img/temai/6cbafd46dd48c9f47129b9dc6a2252c8www800-800~tplv-resize:200:0.webp",
          id: "3436688777953824929",
          price: "￥16.9",
          source: "淘宝",
        },
        {
          name: "【爆款推荐】三都港蒲烧烤鳗210g*2盒 赠烤鳗210g*1盒",
          img: "https://p6-aio.ecombdimg.com/img/temai/12be158d4f6ba5849d340769101f0b29www800-800~tplv-resize:200:0.webp",
          id: "3506639567170203237",
          price: "￥179",
          source: "京东",
        },
        {
          name: "雪燕耳【达人专享】有机本草银耳60g免煮加送30g本品送葡式小勺",
          img: "https://p9-aio.ecombdimg.com/img/temai/82e96f7cc4be07b813de8cd6e81556f0www800-800~tplv-resize:200:0.webp",
          id: "3509208535537966497",
          price: "￥218",
          source: "考拉",
        },
      ],

      visible: false,

      id: "",
      source: "",
      goodsList: [],
      listSelected: [],
      goodsSelectedList: [],
      idx: 1,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.id = this.source = "";
        this.goodsList = this.goods;
        this.goodsSelectedList = [];
      } else {
        this.$refs.goodsTable.clearSelection();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.setSort();
    });
  },
  methods: {
    setSort() {
      const vm = this;
      const el = this.$refs.dragTable.$el.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];

      this.sortable = Sortable.create(el, {
        group: {
          name: "d",
          pull: "clone",
        },
        handle: ".draggable",
        onEnd: function ({ oldIndex, newIndex }) {
          const list = [...vm.list];
          list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
          vm.list = list;
        },
      });
    },
    setMd(row) {
      this.$prompt("设置商品卖点", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "请输入卖点文案",
        inputValue: row.md,
      }).then(({ value }) => {
        row.md = value;
      });
    },
    search() {
      let list = this.goods;
      if (this.id) {
        list = this.goods.filter((item) => {
          return (
            item.id.indexOf(this.id) != -1 || item.name.indexOf(this.id) != -1
          );
        });
      }
      if (this.source) {
        list = list.filter((item) => {
          return item.source == this.source;
        });
      }
      this.goodsList = list;
    },
    handleSelectionChangeList(val) {
      this.listSelected = val;
    },
    handleSelectionChangeGoods(val) {
      this.goodsSelectedList = val;
    },
    add() {
      let i = 0;
      this.list = this.goodsSelectedList.map((item) => {
        return { ...item, index: ++i, md: "" };
      });
      this.visible = false;
    },
    removeList() {
      this.listSelected.forEach((n) => {
        this.list.splice(
          this.list.findIndex((item) => item.id == n.id),
          1
        );
      });
      if (this.idx == 1) {
        const classChapterId = localStorage.getItem("mockChapterId");
        submit({
          classChapterId,
          content: this.list.length,
        }).then((res) => {
          this.$message.success("模拟操作已完成，后续操作将不计分");
        });
      }
      this.idx++;
    },
    remove(row) {
      this.list.splice(
        this.list.findIndex((item) => item.id == row.id),
        1
      );
      if (this.idx == 1) {
        const classChapterId = localStorage.getItem("mockChapterId");
        submit({
          classChapterId,
          content: this.list.length,
        }).then((res) => {
          this.$message.success("模拟操作已完成，后续操作将不计分");
        });
      }
      this.idx++;
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  padding: 20px;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      display: flex;
      align-items: center;

      .title {
        color: #19191a;
        display: inline-block;
        font-size: 18px;
        font-weight: 500;
        line-height: 26px;
        margin-right: 8px;
      }

      .tag {
        background: #f5f7fa;
        color: #707173;
        border-radius: 2px;
        display: inline-block;
        font-size: 12px;
        line-height: 16px;
        padding: 2px 8px;
      }

      .tips {
        margin-left: 8px;
        margin-top: -2px;
      }
    }

    .btn {
      height: 32px;
      width: 88px;
      box-shadow: none;
      font-size: 14px;
      padding: 0;
      color: #12141a;
      background: #fff;
      border: 1px solid #d5d6de;

      &:hover {
        background: #fff;
        border-color: #7570fb;
        color: #7570fb;
        z-index: 3;
      }

      &.del {
        &.is-disabled {
          background: rgba(0, 0, 0, 0.04);
          border-color: transparent;
          color: #afb1bd;
        }
      }

      &.add {
        margin-right: 8px;
        width: 104px;
        background: #6557fa;
        border: 1px solid transparent;
        color: #fff;

        &:hover {
          background: #7570fb;
          border-color: transparent;
          color: #fff;
          z-index: 3;
        }
      }
    }
  }

  .table {
    margin-top: 24px;

    &::v-deep .el-table {
      color: #131520;
      overflow: initial;

      &::before {
        content: none;
      }
      thead {
        color: #515361;
        height: 55px;
      }
      .el-table__empty-text {
        color: #131520;
      }

      .el-checkbox {
        .is-checked,
        .is-indeterminate {
          .el-checkbox__inner {
            border-color: #6557fa;
            background-color: #6557fa;
          }
        }
        .is-focus {
          .el-checkbox__inner {
            border-color: #6557fa;
          }
        }
      }

      .el-checkbox__inner {
        &:hover {
          border-color: #6557fa;
        }
      }
    }

    .draggable {
      position: absolute;
      left: -52px;
      background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDcgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMiAxQzIgMS41NTIyOCAxLjU1MjI4IDIgMSAyQzAuNDQ3NzE1IDIgMCAxLjU1MjI4IDAgMUMwIDAuNDQ3NzE1IDAuNDQ3NzE1IDAgMSAwQzEuNTUyMjggMCAyIDAuNDQ3NzE1IDIgMVpNNyAxQzcgMS41NTIyOCA2LjU1MjI4IDIgNiAyQzUuNDQ3NzIgMiA1IDEuNTUyMjggNSAxQzUgMC40NDc3MTUgNS40NDc3MiAwIDYgMEM2LjU1MjI4IDAgNyAwLjQ0NzcxNSA3IDFaTTEgN0MxLjU1MjI4IDcgMiA2LjU1MjI4IDIgNkMyIDUuNDQ3NzIgMS41NTIyOCA1IDEgNUMwLjQ0NzcxNSA1IDAgNS40NDc3MiAwIDZDMCA2LjU1MjI4IDAuNDQ3NzE1IDcgMSA3Wk03IDZDNyA2LjU1MjI4IDYuNTUyMjggNyA2IDdDNS40NDc3MiA3IDUgNi41NTIyOCA1IDZDNSA1LjQ0NzcyIDUuNDQ3NzIgNSA2IDVDNi41NTIyOCA1IDcgNS40NDc3MiA3IDZaTTEgMTJDMS41NTIyOCAxMiAyIDExLjU1MjMgMiAxMUMyIDEwLjQ0NzcgMS41NTIyOCAxMCAxIDEwQzAuNDQ3NzE1IDEwIDAgMTAuNDQ3NyAwIDExQzAgMTEuNTUyMyAwLjQ0NzcxNSAxMiAxIDEyWk03IDExQzcgMTEuNTUyMyA2LjU1MjI4IDEyIDYgMTJDNS40NDc3MiAxMiA1IDExLjU1MjMgNSAxMUM1IDEwLjQ0NzcgNS40NDc3MiAxMCA2IDEwQzYuNTUyMjggMTAgNyAxMC40NDc3IDcgMTFaIiBmaWxsPSIjNjU1N2ZhIi8+Cjwvc3ZnPgo=)
        center center / 7px 12px no-repeat;
      cursor: move;
      width: 8px;
      height: 14px;
    }

    &::v-deep  .el-input {
      .el-input__inner {
        height: 32px;
        line-height: 32px;
        &:hover,
        &:focus {
          background-color: #fff;
          border-color: #6557fa;
          border-right-width: 1px !important;
        }
      }
    }

    .goods {
      display: flex;
      position: relative;

      .img {
        border-radius: 4px;
        background-image: none;
        background-size: contain;
        display: inline-block;
        overflow: hidden;
        position: relative;
        text-align: center;
        flex: 0 0 64px;
        height: 64px;
        width: 64px;
      }

      .name {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 8px;
        span {
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          color: #0d0d0d;
          display: -webkit-box;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          word-break: break-all;
        }
      }
    }

    .md {
      color: #0d0d0d;
      line-height: 20px;
      margin-bottom: 2px;
      max-width: 110px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .ctrl {
      color: #6557fa;
      display: inline-block;
      line-height: 16px;
      font-weight: 500;
      cursor: pointer;
      outline: none;
      text-decoration: none;
      transition: color 0.3s;
    }
  }

  &::v-deep  .el-drawer__wrapper {
    .el-drawer__header {
      border-bottom: 1px solid #ebecf2;
      height: 54px;
      margin: 0;
      padding: 16px 24px;
      span {
        color: #131520;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
      }
    }
  }

  .drawer {
    .content {
      display: flex;
      flex-direction: column;
      height: 100%;
      position: relative;

      &::v-deep  .el-tabs {
        flex: 1;
        padding: 24px;
        height: calc(100vh - 54px - 80px);
        position: relative;
        .el-tabs__header {
          margin: 0;
        }
        .el-tabs__content {
          height: 100%;
          .el-tab-pane {
            display: flex;
            flex-direction: column;
            height: 100%;
            overflow: auto;
          }
        }
        .el-tabs__item {
          color: #515361;
          //   margin: 0 16px;
          padding: 0 16px 16px 16px;
          height: auto;
          line-height: normal;
          &:nth-child(2) {
            padding-left: 0;
          }

          &.is-active {
            color: #6557fa;
            font-weight: bold;
            outline: none;
          }
          &:hover {
            color: #7570fb;
          }

          svg {
            fill: currentColor;
            height: 1em;
            overflow: hidden;
            vertical-align: -0.15em;
            width: 1em;
          }
        }

        .el-tabs__active-bar {
          height: 3px;
          background-color: #6557fa;
        }
        .el-tabs__nav-wrap::after {
          border-bottom: 1px solid #ebecf2;
          background: none;
        }
      }

      .search-box {
        color: #515361;
        margin: 24px 0 0;
        padding-bottom: 24px;

        span {
          color: #515361;
          display: inline-block;
          font-size: 14px;
          line-height: 22px;
        }

        &::v-deep  .el-input {
          width: 216px;
          // height: 32px;
          margin-left: 16px;
          margin-right: 24px;

          .el-input__inner {
            height: 32px;
            line-height: 32px;

            &:hover,
            &:focus {
              background-color: #fff;
              border-color: #6557fa;
              border-right-width: 1px !important;
            }
          }
        }

        &::v-deep  .el-select {
          .el-input__icon {
            line-height: 32px;
          }
        }

        .btn {
          height: 32px;
          width: 74px;

          box-shadow: none;
          font-size: 14px;
          padding: 0;
          color: #12141a;
          background: #fff;
          border: 1px solid #d5d6de;

          &:hover {
            background: #fff;
            border-color: #7570fb;
            color: #7570fb;
            z-index: 3;
          }

          &.sub {
            background: #6557fa;
            border: 1px solid transparent;
            color: #fff;

            &:hover {
              background: #7570fb;
              border-color: transparent;
              color: #fff;
              z-index: 3;
            }
          }
        }
      }

      .table {
        margin-top: 0;
      }

      .footer {
        align-items: center;
        border-top: 1px solid #edeff2;
        box-shadow: 0 -1px 3px 0 rgb(0 0 0 / 5%);
        display: flex;
        flex-shrink: 0;
        justify-content: space-between;
        margin-top: 16px;
        min-height: 64px;
        padding: 0 24px;

        .btn {
          height: 32px;
          width: 88px;
          box-shadow: none;
          font-size: 14px;
          padding: 0;
          color: #12141a;
          &:hover {
            background: #fff;
            border-color: #7570fb;
            color: #7570fb;
            z-index: 3;
          }
        }

        .sub {
          background: #6557fa;
          border: 1px solid transparent;
          color: #fff;
          &:hover {
            background: #7570fb;
            border-color: transparent;
            color: #fff;
            z-index: 3;
          }
          &.is-disabled {
            background: #ececfe;
            border-color: transparent;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>